export default (v) => {
    if (!v) {
        return ''
    }
    return (parseInt(v) === 1) ? 'PESOS' : 'DOLAR'
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/monedaTxt.js